import _footer from "./_footer";
import _sidebar from "./_sidebar";
import _header from "./_header";

const Partial = {  Footer: _footer, SideBar: _sidebar, Header: _header };

export default Partial;